import { buildModelManager } from "../builder.js";
const DefaultProfilePublicPhotoSelection = {
  __typename: true,
  id: true,
  caption: true,
  createdAt: true,
  orderIdx: true,
  photo: { url: true, mimeType: true, fileName: true },
  photoUrl: true,
  profileId: true,
  updatedAt: true
};
const modelApiIdentifier = "profilePublicPhoto";
const pluralModelApiIdentifier = "profilePublicPhotos";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultProfilePublicPhotoSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultProfilePublicPhotoSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultProfilePublicPhotoSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultProfilePublicPhotoSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultProfilePublicPhotoSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultProfilePublicPhotoSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultProfilePublicPhotoSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createProfilePublicPhoto",
    operationReturnType: "CreateProfilePublicPhoto",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      profilePublicPhoto: { required: false, type: "CreateProfilePublicPhotoInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfilePublicPhotoSelection
  },
  {
    type: "action",
    operationName: "bulkCreateProfilePublicPhotos",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateProfilePublicPhotosInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultProfilePublicPhotoSelection
  },
  {
    type: "action",
    operationName: "updateProfilePublicPhoto",
    operationReturnType: "UpdateProfilePublicPhoto",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      profilePublicPhoto: { required: false, type: "UpdateProfilePublicPhotoInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfilePublicPhotoSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateProfilePublicPhotos",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateProfilePublicPhotosInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultProfilePublicPhotoSelection
  },
  {
    type: "action",
    operationName: "deleteProfilePublicPhoto",
    operationReturnType: "DeleteProfilePublicPhoto",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteProfilePublicPhotos",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertProfilePublicPhoto",
    operationReturnType: "UpsertProfilePublicPhoto",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      profilePublicPhoto: { required: false, type: "UpsertProfilePublicPhotoInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateProfilePublicPhotoResult": { hasReturnType: false },
      "... on UpdateProfilePublicPhotoResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultProfilePublicPhotoSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertProfilePublicPhotos",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertProfilePublicPhotosInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultProfilePublicPhotoSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "profilePublicPhotoGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ProfilePublicPhotoManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultProfilePublicPhotoSelection,
  operations
);
export {
  DefaultProfilePublicPhotoSelection,
  ProfilePublicPhotoManager
};
//# sourceMappingURL=ProfilePublicPhoto.js.map
